export default "__VITE_ASSET__DhX8fHHq__"